import type { FaireProductEntity } from "../../entity_types/product";

export const p_j6ey9vxseu: FaireProductEntity = {
  token: "p_j6ey9vxseu",
  type: "product",
  name: "Korean Soups",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/44d3cee0b6b40a261f12b21e68b6cef1d39f231e17a60a40ccbbd82f8885cc86.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a679f64c0e3f2f119870941e7f3eb25a893d6d319abb535ea45cec26491b852.png",
    "https://cdn.faire.com/fastly/13c156edec0157183542dd08786402b7e7fc375aac18b306fbdf57956d65b940.jpeg",
    "https://cdn.faire.com/fastly/265cc3e342e68be1199a1615cec1e0946e8eb93172046640f7b767309bac595a.jpeg",
    "https://cdn.faire.com/fastly/8a602b94a2d04c7dd2fd90beb752312053c0df3816992af6cdc6732be865cf94.jpeg",
    "https://cdn.faire.com/fastly/de14dcf17c6072b697e32eee28a6889681df1dbf1fcb4dc8090de0dcb4da8164.jpeg",
    "https://cdn.faire.com/fastly/93d6da3dc38c17476213b94b3e1c1272298c54c09218b65d5cfac221a50291c7.jpeg",
    "https://cdn.faire.com/fastly/953ae285e00b079245ad74514ab530fcf864163c5eada99b18baac201851be5f.jpeg",
    "https://cdn.faire.com/fastly/7adedca2187e5e463526ed1a754abd7c073ce093121d74481cc8a26edb062fcd.jpeg",
    "https://cdn.faire.com/fastly/3daef6389c584bcc1014bfa10e131247288d520957220c6e90b005c746245f2c.jpeg",
    "https://cdn.faire.com/fastly/e68bffd31ff7d0e094e10480c2db9f962c9fc1ee0b6e4578d7dce93059b8dd99.jpeg",
    "https://cdn.faire.com/fastly/4369ee4b1f6cf9af81d099c12b094ecb19ebf315fa6418ee9307aa6085466c74.jpeg"
  ],
  priceDollars: 16,
  description: "Discover soul-warming broths, soups, stews, and hot pots found at the heart of Korean cuisine. _Korean Soups_ is a definitive guide to learning about the ingredients, inspirations, and traditional Korean techniques for preparing flavorful, easy, and classic Korean soups. Featuring more than 50 inspiring and delicious recipes, readers will learn how to make: Spicy Braised Chicken Stew for a quick and comforting midweek meal, Refreshing Cold Cucumber Soup in summer, Thinly Sliced Beef Bulgogi Hot Pot for entertaining guests, Kimchi and Soybean Sprout Soup to nourish and restore. To accompany are 13 foundational side-dish recipes, including rice, kimchi, and pickles, for perfectly pairing with soup. Authors Clara Lee and Eddo Kim are the co-founders of Queens, a San Francisco-based Korean food company. They offer an experts’ guide to shopping for a thoughtfully curated, well-stocked Korean pantry and invite you into their home kitchen to help you turn these ingredients into magical guks, tangs, jjigaes, and jeongols through their simple and straightforward methods and recipes.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:59.461Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
